var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorrowersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 10.8001C13.9886 10.8001 15.6003 9.18832 15.6003 7.2001C15.6003 5.21187 13.9886 3.6001 12.0003 3.6001C10.0121 3.6001 8.40034 5.21187 8.40034 7.2001C8.40034 9.18832 10.0121 10.8001 12.0003 10.8001Z",
    fill: "#F2C94C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60034 21.6001C3.60034 16.9609 7.36115 13.2001 12.0003 13.2001C16.6395 13.2001 20.4003 16.9609 20.4003 21.6001H3.60034Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowersIcon);
export default __webpack_public_path__ + "static/media/borrowers_icon.76d20d68579e3ab2a093c475d1a7a87c.svg";
export { ForwardRef as ReactComponent };